import { render } from "./StorageLocation.vue?vue&type=template&id=5085387d&scoped=true"
import script from "./StorageLocation.vue?vue&type=script&lang=js"
export * from "./StorageLocation.vue?vue&type=script&lang=js"

import "./StorageLocation.vue?vue&type=style&index=0&id=5085387d&scoped=true&lang=css"
import "./StorageLocation.vue?vue&type=style&index=1&id=5085387d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5085387d"]])

export default __exports__